import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Toaster } from './components/Sonner';
import { AppTopNav } from './components/AppTopNav';
import { EventsProvider } from './contexts/EventsContext';
import { ExpertsDirectory } from './pages/ExpertsDirectory';
import { ExpertProfile } from './pages/ExpertProfile';
import { EventsList } from './pages/EventsList';
import { EventDetail } from './pages/EventDetail';
import { Tiers } from './pages/Tiers';
import { Applicants } from './pages/Applicants';
import { ApplicantsProvider } from './contexts/ApplicantsContext';
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="31c9uy3vtszrg">
      <EventsProvider data-id="element-1" data-mp="31ctd9lpe1q60">
        <ApplicantsProvider data-id="element-2" data-mp="2wk06ksad07ra">
        <div className="min-h-screen w-full bg-muted/30 font-heading" data-id="element-3" data-mp="2wjqff1dkvuk0">
          <AppTopNav data-id="element-4" data-mp="28u5y0mx2p5cu" />
          <Routes data-id="element-5" data-mp="28tmdcyg1g2v4">
            <Route path="/" element={<ExpertsDirectory data-id="element-7" data-mp="28sbbj465l56n" />} data-id="element-6" data-mp="28t4l0cwhy8sh" />
            <Route path="/experts/:id" element={<ExpertProfile data-id="element-9" data-mp="23ujjma5idj2g" />} data-id="element-8" data-mp="23vktwcepa1j4" />
            <Route path="/events" element={<EventsList data-id="element-11" data-mp="3ik7k0rkruvvx" />} data-id="element-10" data-mp="23t8h0dnsuhcx" />
            <Route path="/events/:id" element={<EventDetail data-id="element-13" data-mp="3ihv048vgebg8" />} data-id="element-12" data-mp="3iiwasc8k4vxf" />
            <Route path="/tiers" element={<Tiers data-id="element-15" data-mp="3mkho1yp07c85" />} data-id="element-14" data-mp="3mlax56bfqdtg" />
            <Route path="/applicants" element={<Applicants data-id="element-17" data-mp="3rc9co3oln7vn" />} data-id="element-16" data-mp="3mjq27fl7ksv2" />
            <Route path="*" element={<ExpertsDirectory data-id="element-19" data-mp="3rcsyvwla8ifh" />} data-id="element-18" data-mp="3rbzq6q2rjiup" />
          </Routes>
        </div>
        <Toaster position="bottom-right" data-id="element-20" data-mp="67znpl2q47d" />
        </ApplicantsProvider>
      </EventsProvider>
    </BrowserRouter>;
}